var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 13.75H15.95C16.225 13.75 16.5 13.475 16.5 13.2V7.425C16.5 7.15 16.225 6.875 15.95 6.875H14.3C14.025 6.875 13.75 7.15 13.75 7.425V13.2C13.75 13.475 14.025 13.75 14.3 13.75ZM18.425 13.75H20.075C20.35 13.75 20.625 13.475 20.625 13.2V3.3C20.625 3.025 20.35 2.75 20.075 2.75H18.425C18.15 2.75 17.875 3.025 17.875 3.3V13.2C17.875 13.475 18.15 13.75 18.425 13.75ZM6.05 13.75H7.7C7.975 13.75 8.25 13.475 8.25 13.2V10.175C8.25 9.9 7.975 9.625 7.7 9.625H6.05C5.775 9.625 5.5 9.9 5.5 10.175V13.2C5.5 13.475 5.775 13.75 6.05 13.75ZM10.175 13.75H11.825C12.1 13.75 12.375 13.475 12.375 13.2V4.675C12.375 4.4 12.1 4.125 11.825 4.125H10.175C9.9 4.125 9.625 4.4 9.625 4.675V13.2C9.625 13.475 9.9 13.75 10.175 13.75ZM21.3125 16.5H2.75V3.4375C2.75 3.05766 2.44234 2.75 2.0625 2.75H0.6875C0.307656 2.75 0 3.05766 0 3.4375V17.875C0 18.6343 0.615742 19.25 1.375 19.25H21.3125C21.6923 19.25 22 18.9423 22 18.5625V17.1875C22 16.8077 21.6923 16.5 21.3125 16.5Z",
    fill: "#FB3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/levels.4a680823bb1777498d0f8a8b309817f7.svg";
export { ForwardRef as ReactComponent };